"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _click = _interopRequireDefault(require("../click"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _printComponent = _interopRequireDefault(require("../printComponent"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputImage/index.js";
var defaultProps = {
  height: "250px"
};
function InputImage(_ref) {
  var className = _ref.className,
    value = _ref.value,
    onChange = _ref.onChange,
    saveImage = _ref.saveImage,
    print = _ref.print,
    height = _ref.height,
    disabled = _ref.disabled;
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    progress = _React$useState2[0],
    setProgress = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(null),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    image = _React$useState4[0],
    setImage = _React$useState4[1];
  var printRef = _react["default"].useRef();
  function readImage(file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      setImage(e.target.result);
    };
    reader.readAsDataURL(file);
  }
  function onFileSelected(file) {
    readImage(file);
    var options = {
      progress: function progress(value) {
        return setProgress(value * 100);
      }
    };
    saveImage.execute(file, options).then(function (result) {
      setImage(result.url);
      setProgress(0);
      onChange(result.url);
    })["catch"](function (error) {
      console.log('error', error);
    });
  }
  function onClick() {
    if (disabled) return;
    var input = document.createElement('input');
    input.type = "file";
    input.accept = 'img';
    input.onchange = function (e) {
      var _e$target$files = (0, _slicedToArray2["default"])(e.target.files, 1),
        file = _e$target$files[0];
      file && onFileSelected(file);
    };
    (0, _click["default"])(input);
  }
  function onClickIcon(e) {
    e.stopPropagation();
    (0, _printComponent["default"])(printRef.current, "image").then(function (result) {
      console.log(result);
    })["catch"](function (error) {
      alert(error);
    });
  }
  function onRemoveImage(e) {
    e.stopPropagation();
    setImage(null);
    onChange("");
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: printRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 17
    }
  }, value && /*#__PURE__*/_react["default"].createElement("img", {
    src: value,
    alt: "Image",
    style: {
      margin: "100px"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 21
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    className: (0, _classNames["default"])("rounded bg-light d-flex position-relative cursor-pointer", className),
    style: {
      height: height
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex justify-content-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "img-fluid",
    src: image || value,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 21
    }
  })), !(image || value) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex ",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-image display-3 text-muted m-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 29
    }
  })), progress > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 bg-black bg-opacity-50",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 37
    }
  }), progress > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "m-auto text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 29
    }
  }, progress.toFixed(0), "%")), print && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute w-100 text-end p-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClickIcon,
    className: "btn btn-secondary",
    disabled: disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-printer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 33
    }
  }))), (image || value) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute w-100 text-start p-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onRemoveImage,
    className: "btn btn-link text-danger",
    disabled: disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-trash",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 33
    }
  })))));
}
InputImage.defaultProps = defaultProps;
var _default = exports["default"] = InputImage;